<template>
  <div class="hello" >
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <div>
          <!-- <span>{{hallInfo.hallName}}</span>
          <span>请选择您所需要预约的部门</span>
          <span>{{ $store.state.dept.deptName }}</span> -->
        </div>
        <div class="input-left">
          <el-input
              v-model="keyword"
              @change="getPriorProjectList"
              placeholder="请输入事项名称"
              clearable
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <div class="box">
        <div class="content"
             :class="active===index?'activeClass':''"
             v-for="(i,index) in data"
             @click="itemsClick(index)">
          <p>{{ i.projectName }}</p>
        </div>
      </div>
    </el-card>
    <div class="pages">
      <el-pagination
          :current-page="page"
          :page-size="size"
          :total="total"
          :page-sizes="[20, 40]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getProjectNameCount} from "@/api/project"
import wasm from "@/mixins/wasm"
import {getHallInfo} from "@/api/hall";
export default {
  name: 'stepTwoItem',
  mixins: [wasm],
  data() {
    return {
      keyword: '',
      active: 0,
      page: 1,
      size: 20,
      total: 0,
      data: [],
      hallInfo: {}
    }
  },
  async mounted() {
    await this.initwasm().then(() => {
      this.getPriorProjectList()
    })
  },
  methods: {
    getHallInfo() {
      let data = {
        hallId: this.$route.query.hallId,
      }
      getHallInfo(data).then(res => {
        this.hallInfo = res.data.info
      })
    },
    getPriorProjectList() {
      debugger
      let data = {
        projectName: this.keyword
      }
      getProjectNameCount(this.page, this.size, data).then(res => {
        this.data = res.data.rows
        this.total = res.data.records
        this.itemsClick(0)
      })
    },
    handleSizeChange(val) {
      this.size = val
      this.getPriorProjectList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getPriorProjectList()
    },
    itemsClick(index) {
      this.active = index
      this.$store.commit('setItem', this.data[index])
    }
  }
}
</script>

<style lang="less" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .input-left {
    width: 20%;
  }

  span {
    margin: 0 10px;
  }

  span:nth-child(1) {
    font-weight: 500;
  }

  span:nth-child(3) {
    color: #427AF4;
  }
}

::v-deep .box {
  height: 300px;
  overflow: auto;
  .el-collapse-item__header {
    border: none;
    background: linear-gradient(to bottom, #F4F5F8, #FFFFFF, #F4F5F8);
    margin: 10px 0;
    box-shadow: 0px 4px 10.8px 0px #C0CBD769;
    height: 60px;

  }

  .el-collapse {
    border: none;
  }

  .el-collapse-item__wrap {
    border: none;
  }

  .el-collapse-item__arrow {
    display: none;
  }

  .titles:before {
    width: 4px;
    background-color: #427AF4;
    content: '';
    height: 20px;
    position: absolute;
    left: 0;
    top: 15px;
  }

  .titles {
    position: relative;
    padding-left: 20px;
    font-size: 14px;
    font-weight: 400;
  }
}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background: #FAFAFB;
  font-size: 14px;
  font-weight: 400;
  margin: 10px 0;

  .btn {
    background: #427AF4;
  }
}

::v-deep .pages {
  margin: 20px 0;

  .el-pagination {
    display: flex;
  }

  .el-pagination__sizes {
    margin-left: auto;
  }
}

.activeClass {
  background: #427AF4;
  color: #fff;
}
</style>
